
import { useParams } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import Sheet from '@mui/joy/Sheet'
import Divider from '@mui/joy/Divider';
import CollabList from './CollabList';

function _ProjectAssets() {

    const { projectKey = "" } = useParams<{ projectKey: string }>();

    if (!projectKey) {
        return null;
    }

    return (
        <>

            <Divider>This is part of a larger project</Divider>

        <Sheet
            sx={{
                borderRight: '1px solid',
                borderColor: 'divider',
                overflowAnchor: 'none',
                display: 'flex',
                flexGrow: 1,
                flexDirection: 'column',
                flexShrink: 1,
            }}
        >

            <CollabList projectKey={projectKey} />

        </Sheet>
        </>
    );
}



const cp = observer(_ProjectAssets);
export default cp;
